<template>
    <div class="section" id="about">
        <div id="abtme">ABOUT</div>
        <div id="aboutme">
            <img id="abtmeimg" src="https://images.unsplash.com/photo-1646900983776-34d811fd7f50?ixlib=rb-1.2.1&ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&auto=format&fit=crop&w=764&q=80" alt="">
            <div id="texting" >Experienced and self-motivated Full Stack web Devloper with two years of personel experience . Building diffrente types of web application . Hardworking engineering student , problem solver and passionate for technolgy </div>

        </div>
        <div id="back">&lt;</div>


    </div>
</template>
<script>
    export default {
        name : 'About'
    }
</script>